import { Children } from "react";
import Icon from "./icons/Icon";
import "./Leiste.css";

/**
 * Hinweis-Leiste im Spiel, direkt unter dem Kopf (schiebt den Inhalt nach
 * unten statt STOPP zu verdecken). farbe: "gelb" = wartet auf jemanden,
 * "rot" = Verbindung. dreht: Lade-Kreisel statt Knopf. children: Knoepfe —
 * einer steht rechts neben dem Text, mehrere bekommen eine eigene Zeile
 * darunter (nebeneinander quetschten sie den Text auf ein Wort pro Zeile).
 * @category bausteine
 */
export function Leiste({ farbe = "gelb", icon, titel, text, dreht = false, children }) {
  const knoepfe = Children.toArray(children).filter(Boolean);
  return (
    <div className={`leiste ${farbe}${knoepfe.length > 1 ? " mehrere" : ""}`} role="status">
      <span className="leiste-ikon">
        <Icon name={icon} size={18} />
      </span>
      <span className="leiste-text">
        <b>{titel}</b>
        {text && <small>{text}</small>}
      </span>
      {dreht && <span className="leiste-dreher" aria-hidden="true" />}
      {knoepfe.length > 0 && <span className="leiste-knoepfe">{knoepfe}</span>}
    </div>
  );
}

export default Leiste;
